import styles from "./style.module.css";

const TicketButtonBox = ({ children, className, ...props }) => {
  return (
    <div className={[styles.authbox, className].join(" ")} {...props}>
      {children}
    </div>
  );
};

export default TicketButtonBox;
